export const dictionaries: { [key: string]: () => Promise<Localication> } = {
    en: () => import('./en.ts').then(module => module.default),
    ar: () => import('./ar.ts').then(module => module.default),
    fr: () => import('./fr.ts').then(module => module.default),
    it: () => import('./it.ts').then(module => module.default),
    es: () => import('./es.ts').then(module => module.default),
    pt: () => import('./pt.ts').then(module => module.default),
    uk: () => import('./uk.ts').then(module => module.default)
}
